// extracted by mini-css-extract-plugin
module.exports = {"StateSection":"StateSection_StateSection__1tyvm","fade":"StateSection_fade__2scGA","StateStats":"StateSection_StateStats__3yW7c","StateZones":"StateSection_StateZones__9CLV0"};